export default __webpack_public_path__ + "static/media/icon_finishingtype_MokumeGane.ffc737d5.png";